import $ from 'jquery';

export default class Spotlight {
  constructor(element) {
    this.$element = $(element);
    this.process();
  }

  process() {
    const type = this.$element.find('.post-type').text();
    this.$element.find('.node-header a').prepend(`<span class="type">${type}</span>`);
  }
}
